/* --- advanced-tabs.jsbd_ver2.1.0 --- */
"use strict";

(function () {
  function managedlsTabs() {
    const tabContentSelector = ".dls-advanced-tabs-content";
    const tabsSelector = ".dls-advanced-tabs";

    function getAdvancedTabsParent(selector) {
      return document.querySelector(selector)?.closest(tabsSelector);
    }

    function getAdvancedTabsNodeId(selector) {
      const advancedTabsElement = getAdvancedTabsParent(selector);

      if (advancedTabsElement) {
        return advancedTabsElement.dataset?.nodeId;
      }

      return null;
    }

    function alertIfTabLinkAndTabContentDontMatch(advancedTabsNodeId) {
      const advancedTabs = document.querySelector(
        `[data-node-id="${advancedTabsNodeId}"]`
      );
      const tabsMenu = advancedTabs.querySelectorAll(".js-tab");
      const tabsPanels = advancedTabs.querySelectorAll(".js-panel");

      if (!tabsMenu || !tabsPanels) return;

      const tabLinksCount = tabsMenu.length;
      const tabContentsCount = tabsPanels.length;

      if (tabLinksCount > tabContentsCount) {
        const plural = tabLinksCount - tabContentsCount > 1 ? "s" : "";

        window.parent.dls.NotificationLogger.log.message(
          `You're missing ${
            tabLinksCount - tabContentsCount
          } "Tab Content" element${plural} in a "Advanced Tabs" element. `,
          8000
        );
      }

      if (tabLinksCount < tabContentsCount) {
        const plural = tabContentsCount - tabLinksCount > 1 ? "Tabs" : "Tab";

        window.parent.dls.NotificationLogger.log.message(
          `You're missing ${
            tabContentsCount - tabLinksCount
          } "${plural}" in a "Advanced Tabs" element.`,
          8000
        );
      }
    }

    function activateTabFromStructurePanel(selector) {
      const advancedTabsNodeId = getAdvancedTabsNodeId(selector);

      const tabsContentElement = document
        .querySelector(selector)
        ?.closest(tabContentSelector);

      if (
        window.dlsTabsInstances &&
        window.dlsTabsInstances[advancedTabsNodeId]
      ) {
        window.dlsTabsInstances[
          advancedTabsNodeId
        ].updateAndActivateTabFromSelector(tabsContentElement);
      }
    }

    function update(selector) {
      const advancedTabsNodeId = getAdvancedTabsNodeId(selector);

      if (
        window.dlsTabsInstances &&
        window.dlsTabsInstances[advancedTabsNodeId]
      ) {
        window.dlsTabsInstances[advancedTabsNodeId].update();
      }
    }

    return {
      alertIfTabLinkAndTabContentDontMatch,
      activateTabFromStructurePanel,
      update,
    };
  }

  window.managedlsTabs = managedlsTabs;
})();


/* --- tabs.jsbd_ver2.1.0 --- */
(function() {
  const { mergeObjects, matchMedia } = dlsFrontend.utils;

  const verticalTabsSelector = "is-vertical";

  class dlsTabs {
    defaultOptions = {
      activeTab: 1,
      horizontalAt: "breakpoint_phone_landscape",
      isVertical: false,
      openOnHover: false
    };

    activateTabEventTypes = ["click"];

    keys = {
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      delete: 46
    };

    // Add or substract depending on key pressed
    direction = {
      37: -1,
      38: -1,
      39: 1,
      40: 1
    };

    constructor(selector, options = {}) {
      this.selector = selector;
      this.element = document.querySelector(`${this.selector}`);
      this.isBuilder = !!window?.dlsFrontend.utils.isBuilder();
      this.options = mergeObjects(this.defaultOptions, options);

      this.init();
    }

    bindListeners() {
      if (this.tabs) {
        this.tabs.forEach((tab, index) => {
          this.addListeners(tab, index);
        });
        if (this.tabSelect) {
          this.tabSelect.addEventListener("change", event => {
            this.changeEventListener(event);
          });
        }
      }
    }

    onResizeVertical() {
      if (!this.options.isVertical) return;
      const breakpoint = this.options.horizontalAt;
      const { BASE_BREAKPOINT_ID } = window.dlsFrontend.data;

      if (
        (matchMedia(breakpoint) && this.options.isVertical) ||
        (breakpoint === BASE_BREAKPOINT_ID && this.options.isVertical)
      ) {
        this.tabsContainer.classList.remove(verticalTabsSelector);
        this.tabList.setAttribute("aria-orientation", "horizontal");
      } else {
        if (!this.tabsContainer.classList.contains(verticalTabsSelector)) {
          this.tabsContainer.classList.add(verticalTabsSelector);
          this.tabList.setAttribute("aria-orientation", "vertical");
        }
      }
    }

    addListeners(tab, index) {
      this.tabs[index].index = index;
      this.onClick = this.clickEventListener.bind(this);
      this.onKeydown = this.keydownEventListener.bind(this);

      this.activateTabEventTypes.forEach((eventType) => {
        tab.addEventListener(eventType, this.onClick);
      });

      if (this.isBuilder) return;
      tab.addEventListener("keydown", this.onKeydown);
    }

    changeEventListener(event) {
      const tab = document.querySelector(`#${event.target.value}`);
      this.activateTab(tab, false);
    }

    clickEventListener(event) {
      const tab = event.target.closest(".js-tab");
      this.activateTab(tab, false);
    }

    keydownEventListener(event) {
      const key = event.keyCode;

      switch (key) {
        case this.keys.end:
          event.preventDefault();
          // Activate last tab
          this.activateTab(this.tabs[this.tabs.length - 1], true);
          break;
        case this.keys.home:
          event.preventDefault();
          // Activate first tab
          this.activateTab(this.tabs[0], true);
          break;

        // Up and down are in keydown
        // because we need to prevent page scroll >:)
        case this.keys.up:
        case this.keys.down:
        case this.keys.left:
        case this.keys.right:
          this.determineOrientation(event);
          break;
      }
    }

    determineOrientation(event) {
      const key = event.keyCode;

      const vertical =
        this.tabList.getAttribute("aria-orientation") == "vertical";
      let proceed = false;

      if (vertical) {
        if (key === this.keys.up || key === this.keys.down) {
          event.preventDefault();
          proceed = true;
        }
      } else {
        if (key === this.keys.left || key === this.keys.right) {
          proceed = true;
        }
      }

      if (proceed) {
        this.switchTabOnArrowPress(event);
      }
    }

    switchTabOnArrowPress(event) {
      const pressed = event.keyCode;

      this.onFocus = this.focusEventHandler.bind(this);

      this.tabs.forEach(tab => {
        tab.addEventListener("focus", event => this.onFocus(event));
      });

      if (this.direction[pressed]) {
        const target = event.target;
        if (target.index !== undefined) {
          if (this.tabs[target.index + this.direction[pressed]]) {
            this.tabs[target.index + this.direction[pressed]].focus();
          } else if (pressed === this.keys.left || pressed === this.keys.up) {
            this.focusLastTab();
          } else if (pressed === this.keys.right || pressed == this.keys.down) {
            this.focusFirstTab();
          }
        }
      }
    }

    activateTab(tab, setFocus) {
      if (tab) {
        setFocus = setFocus || false;
        // Deactivate all other tabs
        this.deactivateTabs();

        // Remove tabindex attribute
        tab.removeAttribute("tabindex");

        // Set the tab as selected
        tab.setAttribute("aria-selected", "true");

        tab.classList.add("is-active");

        // Get the value of aria-controls (which is an ID)
        const controls = tab.getAttribute("aria-controls");

        if (this.tabSelect) {
          this.tabSelect.value = tab.getAttribute("id");
          this.tabSelect[this.tabSelect.selectedIndex].setAttribute(
            "selected",
            "selected"
          );
        }

        const panel = document.getElementById(controls);

        if (!panel) return;

        panel.classList.add("is-active");

        // Set focus when required
        if (setFocus && !this.isBuilder) {
          tab.focus();
        }

        // Force-refresh animations to allow the ones inside hidden tabs to work.
        const event = new Event("dls_play_animations", { bubbles: true });
        panel.parentElement.dispatchEvent(event);
      }
    }

    refreshPanelAttributes() {
      const firstPanel = document.querySelector(`${this.selector} .js-panel`);
      const panelsContainer = firstPanel.closest(".dls-tabs-content-container");

      this.panels = panelsContainer.querySelectorAll(
        ":scope > .js-panel, :scope > .dls-advanced-tabs-content > .js-panel"
      );

      this.panels.forEach((panel, index) => {
        panel.setAttribute("id", `tab-panel-${this.tabsId}-${index + 1}`);
        panel.setAttribute(
          "aria-labelledby",
          `tab-${this.tabsId}-${index + 1}`
        );
      });
    }

    deactivateTabs() {
      if (this.tabs) {
        this.tabs.forEach(tab => {
          tab.setAttribute("tabindex", "-1");
          tab.setAttribute("aria-selected", "false");
          tab.removeEventListener("focus", event => this.onFocus(event));
          this.activateTabEventTypes.forEach((eventType) => {
            tab.removeEventListener(eventType, event => this.onClick(event));
          });
          tab.removeEventListener("keydown", event => this.onKeydown(event));
          tab.classList.remove("is-active");
        });
      }

      if (this.tabSelect) {
        [...this.tabSelect.options].forEach(option =>
          option.removeAttribute("selected")
        );
      }

      if (this.tabSelect) {
        this.tabSelect.removeEventListener("change", event =>
          this.changeEventListener(event)
        );
      }

      if (this.panels) {
        this.panels.forEach(panel => {
          panel.classList.remove("is-active");
        });
      }
    }

    focusFirstTab() {
      this.tabs[0].focus();
    }

    focusLastTab() {
      this.tabs[this.tabs.length - 1].focus();
    }

    determineDelay() {
      const hasDelay = this.tabList.hasAttribute("data-delay");
      const delay = 0;

      if (hasDelay) {
        const delayValue = this.tabList.getAttribute("data-delay");
        if (delayValue) {
          this.delay = delayValue;
        } else {
          // If no value is specified, default to 300ms
          this.delay = 300;
        }
      }

      return delay;
    }

    focusEventHandler(event) {
      const target = event.target;
      setTimeout(() => this.checkTabFocus(target), this.delay);
    }

    checkTabFocus(target) {
      const focused = document.activeElement;

      if (target === focused) {
        this.activateTab(target, false);
      }
    }

    destroy() {
      if (!this.tabs) return;
      this.deactivateTabs();
      this.resetTabstoVerticalLayout();
      this.destroyResizeObserver();
    }

    destroyResizeObserver() {
      if (!this.resizeObserver) return;
      this.resizeObserver.unobserve(this.element);
    }

    resetTabstoVerticalLayout() {
      this.tabsContainer.classList.remove(verticalTabsSelector);
      this.tabList.setAttribute("aria-orientation", "vertical");
    }

    onResize(callback) {
      this.resizeObserver = new ResizeObserver(callback);
      this.resizeObserver.observe(this.element);

      return () => {
        this.resizeObserver.disconnect();
      };
    }

    update(options) {
      if (options) {
        this.options = mergeObjects(this.defaultOptions, options);
      }
      this.destroy();
      this.init();
    }

    updateAndActivateTabFromSelector(selector) {
      this.refreshPanelAttributes();
      const panel = selector.querySelector(".js-panel");
      const tabId = panel.getAttribute("aria-labelledby");
      if (!tabId) return;
      const tab = document.getElementById(tabId);
      this.activateTab(tab);
    }

    init() {
      if (!this.element) return;

      if (this.options.openOnHover && !this.isBuilder) {
        this.activateTabEventTypes.push("mouseover");
      }

      this.tabList = this.element.querySelector(".js-tablist");
      if (!this.tabList) return;

      this.tabs = this.tabList.querySelectorAll(".js-tab");
      this.tabsContainer = this.tabList.closest(".js-tabs-container");
      this.tabsId =
        this.tabList && this.tabList.dataset.tabsId
          ? this.tabList.dataset.tabsId
          : this.selector.match(/\d+$/)[0];
      this.tabSelect = this.element.querySelector(".js-tab-select");

      this.refreshPanelAttributes();
      this.bindListeners();
      this.activateTab(this.tabs[this.options.activeTab - 1]);

      if (this.options.isVertical) {
        this.onResize(() => this.onResizeVertical());
      }
    }
  }

  window.dlsTabs = dlsTabs;
})();


/* --- dls-advanced-accordion.jsbd_ver2.1.0 --- */
(function () {
  const accordionButtonSelector =
    ".dls-accordion__content-wrapper > .dls-accordion__title-tag > button[aria-expanded]";

  const { mergeObjects, isBuilder } = dlsFrontend.utils;

  class dlsAdvancedAccordion {
    defaultOptions = {
      accordion: false,
      openFirst: false,
      ignoreClickEvent: false
    };

    constructor(selector, options) {
      this.selector = selector;
      this.element = document.querySelector(`${this.selector}`);
      this.options = mergeObjects(this.defaultOptions, options);
      this.isBuilder = isBuilder();
      this.init();
    }

    init() {
      this.elements = this.getAccordions();
      this.handleOnClick = this.onClick.bind(this);

      // Builder: remove click listener in favor of `activateAccordionFromSelector`
      if (!this.options.ignoreClickEvent) {
        this.elements.forEach((accordion) => {
          accordion.addEventListener("click", this.handleOnClick);
        });
      }

      if (this.options.openFirst) {
        this.open(this.elements[0], true);
      }

      if (this.isBuilder && this.elements.length === 1) {
        this.open(this.elements[0], true);
      }
    }

    getAccordions() {
      // Return all accordions that are direct children of the selector.
      // This is to prevent nested accordions from being selected.
      return Array.from(document.querySelectorAll(`${this.selector} > ${accordionButtonSelector}`));
    }

    onClick(event) {
      if (this.options.accordion) {
        this.closeAllAccordions();
      }
      this.toggle(event.currentTarget);
    }

    isTransitioning(item) {
      return item.classList.contains("is-collapsing");
    }

    isActive(item) {
      return item.classList.contains("is-active");
    }

    getOpenAccordion() {
      return this.elements.find((accordion) => this.isActive(this.getAccordionContainer(accordion)));
    }

    getOpenAccordionIndex() {
      return this.elements.indexOf(this.getOpenAccordion());
    }

    getAccordionContent(button) {
      const controlsId = button.getAttribute("aria-controls");
      return this.element.querySelector(`#${controlsId}`);
    }

    getAccordionContainer(button) {
      return button.closest(".dls-accordion__content-wrapper");
    }

    async open(button, instant = false) {
      const containerEl = this.getAccordionContainer(button);
      const contentEl = this.getAccordionContent(button);

      if (this.isTransitioning(containerEl)) return;
      if (this.isActive(containerEl)) return;

      const event = new Event("dls_play_animations", {bubbles: true});
      contentEl.dispatchEvent(event);

      const complete = () => {
        containerEl.classList.add("is-active");
        containerEl.classList.remove("is-collapsing");
        contentEl.style.height = "";
      };

      if (instant) {
        complete();
        button.setAttribute("aria-expanded", true);
        return;
      }

      containerEl.classList.add("is-collapsing");
      contentEl.style.height = "0px";

      const endHeight = this.getEndHeight(contentEl);
      contentEl.style.height = `${endHeight}px`;
      button.setAttribute("aria-expanded", true);

      await this.onTransitionEnd(contentEl);

      complete();
    }

    async close(button, instant = false) {
      const containerEl = this.getAccordionContainer(button);
      const contentEl = this.getAccordionContent(button);

      if (this.isTransitioning(containerEl)) return;
      if (!this.isActive(containerEl) && !this.isBuilder) return;

      if (instant) {
        containerEl.classList.remove("is-active");
        button.setAttribute("aria-expanded", false);
        return;
      }

      const endHeight = this.getEndHeight(contentEl);
      contentEl.style.height = `${endHeight}px`;

      this.reflow(contentEl);

      containerEl.classList.add("is-collapsing");
      containerEl.classList.remove("is-active");
      contentEl.style.height = "";
      button.setAttribute("aria-expanded", false);

      await this.onTransitionEnd(contentEl);

      containerEl.classList.remove("is-collapsing");
    }

    toggle(button) {
      const containerEl = this.getAccordionContainer(button);

      if (this.isActive(containerEl)) {
        this.close(button);
      } else {
        this.open(button);
      }
    }

    closeAllAccordions() {
      this.elements.forEach((accordion) => {
        this.close(accordion);
      });
    }

    closeAllItemsExcept(item, instant = false) {
      this.elements
        .filter((el) => el !== item)
        .forEach((el) => this.close(el, instant));
    }

    destroy() {
      this.elements.forEach((accordion) => {
        this.close(accordion, true);
        accordion.removeEventListener("click", this.handleOnClick);
      });
      this.elements = null;
    }

    getEndHeight(element) {
      const height = element.getBoundingClientRect().height;
      return Math.max(element.scrollHeight, height);
    }

    reflow(element) {
      element.offsetHeight;
    }

    onTransitionEnd(item) {
      const duration = window.getComputedStyle(item)
        .getPropertyValue("transition-duration");

      // If duration is 0s, transitionend will not fire.
      if (duration === "0s") {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        item.addEventListener("transitionend", resolve, {once: true});
      });
    }

    update() {
      this.elements = this.getAccordions();

      this.destroy();
      this.init();
    }

    activateAccordionFromSelector(selector) {
      this.elements = this.getAccordions();

      const buttonEl = selector.querySelector("button[aria-expanded]");
      const index = this.elements.indexOf(buttonEl);

      const item = index !== -1 ? this.elements[index] : this.elements[0];

      this.closeAllItemsExcept(item, true);
      this.open(this.elements[index], true);
    }
  }

  window.dlsAdvancedAccordion = dlsAdvancedAccordion;
})();

/* --- Inline Script --- */

            (function () {
                document.addEventListener("DOMContentLoaded", function (e) {
                    if (document.hasOwnProperty("visibilityState") && document.visibilityState === "prerender") {
                        return;
                    }

                                            if (navigator.webdriver || /bot|crawler|spider|crawling|semrushbot|chrome-lighthouse/i.test(navigator.userAgent)) {
                            return;
                        }
                                        
                    let referrer_url = null;

                    if (typeof document.referrer === 'string' && document.referrer.length > 0) {
                        referrer_url = document.referrer;
                    }

                    const params = location.search.slice(1).split('&').reduce((acc, s) => {
                        const [k, v] = s.split('=');
                        return Object.assign(acc, {[k]: v});
                    }, {});

                    const url = "https://boomn-dev.instawp.xyz/mva/wp-json/iawp/search";
                    const body = {
                        referrer_url,
                        utm_source: params.utm_source,
                        utm_medium: params.utm_medium,
                        utm_campaign: params.utm_campaign,
                        utm_term: params.utm_term,
                        utm_content: params.utm_content,
                        gclid: params.gclid,
                        ...{"payload":{"resource":"singular","singular_id":460,"page":1},"signature":"d68095f0ff5d665ba21918ee68e6757a"}                    };
                    const xhr = new XMLHttpRequest();
                    xhr.open("POST", url, true);
                    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                    xhr.send(JSON.stringify(body));
                });
            })();
        

/* --- Inline Script --- */


/* --- Inline Script --- */


/* --- Inline Script --- */


/* --- Inline Script --- */


/* --- Inline Script --- */
document.addEventListener('DOMContentLoaded', function(){     if (!window.dlsFrontend) {
        window.dlsFrontend = {}
    }

    window.dlsFrontend.data = {"homeUrl":"https:\/\/boomn-dev.instawp.xyz\/mva","ajaxUrl":"https:\/\/boomn-dev.instawp.xyz\/mva\/wp-admin\/admin-ajax.php","elementsPluginUrl":"https:\/\/boomn-dev.instawp.xyz\/mva\/wp-content\/plugins\/dls\/subplugins\/dls-elements\/","BASE_BREAKPOINT_ID":"breakpoint_base","breakpoints":[{"id":"breakpoint_base","label":"Desktop","defaultPreviewWidth":"100%"},{"id":"breakpoint_tablet_landscape","label":"Tablet Landscape","defaultPreviewWidth":1024,"maxWidth":1119},{"id":"breakpoint_tablet_portrait","label":"Tablet Portrait","defaultPreviewWidth":768,"maxWidth":1023},{"id":"breakpoint_phone_landscape","label":"Phone Landscape","defaultPreviewWidth":480,"maxWidth":767},{"id":"breakpoint_phone_portrait","label":"Phone Portrait","defaultPreviewWidth":400,"maxWidth":479}],"subscriptionMode":"pro"} }) 

/* --- Inline Script --- */
document.addEventListener('DOMContentLoaded', function(){ 
new dlsTabs('.dls .dls-advanced-tabs-460-103', { openOnHover: null, activeTab: 1, isVertical: null, horizontalAt: null } );
 }) 

/* --- Inline Script --- */
document.addEventListener('DOMContentLoaded', function(){ 
new dlsAdvancedAccordion('.dls .dls-accordion-460-131', { accordion: true, openFirst: true } );
 }) 

